import script from "./CalculationTransportSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationTransportSection.vue?vue&type=script&setup=true&lang=js"

import "./CalculationTransportSection.vue?vue&type=style&index=0&id=d385c546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d385c546"]])

export default __exports__